import { Notification } from 'element-ui';
// import { Message } from 'element-ui';
import moment from 'moment';
import EventBus from "@/event/EventBus";

export default {

    name: 'baseComponent',

    data() {
        return {
            cardInfo: [
                {
                    id: 'GTX 1050',
                    microarchitecture: 'Pascal - GP107',
                    vram: 2,
                },
                {
                    id: 'GTX 1080 Ti',
                    microarchitecture: 'Pascal - GP102',
                    vram: 11,
                },
                {
                    id: 'RTX 2080 Ti',
                    microarchitecture: 'Turing - TU102',
                    vram: 11,
                },
                {
                    id: 'RTX 3080',
                    microarchitecture: 'Ampere - GA102',
                    vram: 10,
                },
                {
                    id: 'RTX 3090',
                    microarchitecture: 'Ampere - GA102',
                    vram: 24,
                },
                {
                    id: 'RTX A6000',
                    microarchitecture: 'Ampere - GA102',
                    vram: 48,
                },
            ],
            delayLoadingComponent: 500,
            colorDict: {
                1: "color: #F44336;",
                2: "color: #43A047;",
                3: "color: #E53935;",
                6: "color: #1E88E5;",
                8: "color: #FF9800;",
                9: "color: #1E88E5;",
                10: "color: #5E35B1;",
                11: "color: #FF9800;",
                12: "color: #FF9800;",
                13: "color: #FF9800;",
                32773: "color: #1E88E5;",
                32776: "color: #1E88E5;",
                32777: "color: #1E88E5;",
                32779: "color: #1E88E5;",
                32780: "color: #1E88E5;",
            },
            colorAvailability: {
                low: "color: #4CAF50;",
                medium: "color: #2196F3;",
                high: "color: #FF9800;",
                full: "color: #F44336;"
            },
            listStatus: {
                other: 1,
                running: 2,
                off: 3,
                saved: 6,
                offForClone: 8,
                paused: 9,
                starting: 10,
                reset: 11,
                restarting: 12,
                saving: 32773,
                pausing: 32776,
                resuming: 32777,
                fastSaved: 32779,
                fastSaving: 32780,
            },
            isLoading: false,
            loadingStatus: {
                color: '#9E9E9E',
                date: moment().format("DD/MM/YYYY hh:mm:ss [GMT]Z"),
                text: this.$t('loadingStatus.unknown'),
            },
        }
    },

    methods: {        
        matomoLog(Category, Action, Name, Value) {
            if(window.matomoEnabled){
                try {
                    let dataPush = ['trackEvent', Category, Action, Name];
                    if (Value) dataPush.push(Value);
                    if(window._paq) window._paq.push(dataPush);
                } catch (err) { }
            }
        },
        removeVietnameseTones(str) {
            str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
            str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
            str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
            str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
            str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
            str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
            str = str.replace(/đ/g, "d");
            str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
            str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
            str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
            str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
            str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
            str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
            str = str.replace(/Đ/g, "D");
            // Some system encode vietnamese combining accent as individual utf-8 characters
            // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
            str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
            str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
            // Remove extra spaces
            // Bỏ các khoảng trắng liền nhau
            str = str.replace(/ + /g, " ");
            str = str.trim();
            // Remove punctuations
            // Bỏ dấu câu, kí tự đặc biệt
            str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
            return str;
        },



        // Go to payment
        goRechargeView() {
            this.$router.push("/payment-management");
        },

        copyToClipboard(inputId, value) {
            const el = document.querySelector(inputId);
            $(inputId).val(value);
            $(inputId).show();
            el.select();
            el.focus();
            var successful = document.execCommand("copy");
            $(inputId).hide();
            Notification.success({
                title: this.$t('api.copiedTitle'),
                duration: 1500,
                showClose: false,
                message: this.$t('api.copiedMessage')
            });
        },

        // Get status text
        getStatusText(statusVal) {
            switch (statusVal) {
                case this.listStatus.other:
                    return this.$t('statusText.error');
                case this.listStatus.running:
                    return this.$t('statusText.running');
                case this.listStatus.off:
                    return this.$t('statusText.off');
                case this.listStatus.saved:
                    return this.$t('statusText.ready');
                case this.listStatus.paused:
                    return this.$t('statusText.paused');
                case this.listStatus.starting:
                    return this.$t('statusText.starting');
                case this.listStatus.reset:
                    return this.$t('statusText.reset');
                case this.listStatus.restarting:
                    return this.$t('statusText.restarting');
                case this.listStatus.saving:
                    return this.$t('statusText.creating');
                case this.listStatus.pausing:
                    return this.$t('statusText.pausing');
                case this.listStatus.resuming:
                    return this.$t('statusText.resuming');
                case this.listStatus.fastSaved:
                    return this.$t('statusText.fastSaved');
                case this.listStatus.fastSaving:
                    return this.$t('statusText.fastSaving');
            }
            return "";
        },

        notificationSuccess(title, message) {
            Notification.success({
                title: title,
                dangerouslyUseHTMLString: true,
                duration: 3000,
                offset: 60,
                showClose: false,
                message: message,
                type: 'success'
            });
        },
        notificationInfo(title, message) {
            Notification.message({
                title: title,
                dangerouslyUseHTMLString: true,
                duration: 3000,
                offset: 60,
                showClose: false,
                message: message,
                type: 'warning'
            });
        },
        notificationWarning(title, message) {
            Notification.warning({
                title: title,
                dangerouslyUseHTMLString: true,
                duration: 3000,
                offset: 60,
                showClose: false,
                message: message,
                type: 'warning'
            });
        },
        notificationError(title, message) {
            Notification.error({
                title: title,
                dangerouslyUseHTMLString: true,
                duration: 3000,
                offset: 60,
                showClose: false,
                message: message,
                type: 'error'
            });
        },

        // Get information client
        getInformationClient() {
            let information = {
                sourceRequest: 'WEB',
                browserDetails: '',
                timeZone: '',
                resolutionDevice: '',
            };
            let navigatorList = {
                appCodeName: navigator.appCodeName,
                appName: navigator.appName,
                appVersion: navigator.appVersion,
                cookieEnabled: navigator.cookieEnabled,
                geolocation: navigator.geolocation,
                language: navigator.language,
                onLine: navigator.onLine,
                platform: navigator.platform,
                product: navigator.product,
                userAgent: navigator.userAgent
            };
            try {
                information.browserDetails = JSON.stringify(navigatorList);

                let offset = new Date().getTimezoneOffset(),
                    o = Math.abs(offset);
                let timeZoneBrowse = (offset < 0 ? "+" : "-") + Math.floor(o / 60);
                information.timeZone = timeZoneBrowse;

                information.resolutionDevice = `${window.screen.width}x${window.screen.height}`;
            } catch { }
            return information;
        },

        countDown(date) {
            let result = '';

            // Set the date we're counting down to
            let countDownDate = new Date(date).getTime();

            let now = new Date();
            let nowUTC = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());

            // Find the distance between now and the count down date
            let distance = countDownDate - nowUTC;

            // Time calculations for days, hours, minutes and seconds
            let days = Math.floor(distance / (1000 * 60 * 60 * 24));
            let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((distance % (1000 * 60)) / 1000);

            if (seconds > 0) {
                if (seconds < 1) {
                    seconds = parseFloat(seconds).toFixed(2);
                } else {
                    result += (days > 0 ? days + 'd ' : '');
                    result += (hours > 0 ? hours + 'h ' : '');
                    result += (minutes > 0 ? minutes + 'm ' : '');
                }
            }
            else result = 'Expired !';
            return result;
        },

        compareDateNow(date) {
            if (moment.utc(date).valueOf() > moment().valueOf()) {
                return true;
            } else {
                return false;
            }
        },

        //Display duration 
        caclDuration(uptime) {
            let sec = uptime;
            let hrs = Math.floor(sec / 3600);
            let min = Math.floor((sec - (hrs * 3600)) / 60);
            let result = '';
            if (sec > 0) {
                if (sec < 1) {
                    sec = parseFloat(sec).toFixed(2);
                } else {
                    result += (hrs > 0 ? hrs + 'h' : '');
                    result += (min > 0 ? min + 'm' : '');
                }
            }
            else result = '-- : --';
            return result;
        },

        showLoading() {
            $("#loading-element").fadeIn(200);
        },
        hideLoading() {
            $("#loading-element").fadeOut(200);
        },
        showLineLoading(data_id) {
            $(`.line-progress[data-progress-id=${data_id}]`).fadeIn(200);
        },
        hideLineLoading(data_id) {
            $(`.line-progress[data-progress-id=${data_id}]`).fadeOut(200);
        },
        arrayToMap(array) {
            const result = Object.assign({}, ...array.map(s => ({ [s.id]: s })));
            return result;
        },
        getFileExt(fileName) {
            return (/[.]/.exec(fileName)) ? /[^.]+$/.exec(fileName)[0] : undefined;
        },
        imgUrlAlt(event) {
            event.target.src = "/static/image/Extension/file.png"
        },
        showToast(title, message, type) {
            this.$notify({
                group: 'notifi-message',
                type: type,
                title: title,
                text: message
            });
        },
        isNumber: function (evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        toLocaltime(valueConvert) {

            var dateFormat = 'YYYY-DD-MM HH:mm:ss';
            var dateUtc = moment.utc(valueConvert);
            var localDate = dateUtc.local();
            return localDate.format(dateFormat);
        },
        toHHMMSS(valueConvert) {
            var sec_num = parseInt(valueConvert, 10); // don't forget the second param
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (hours < 10) { hours = "0" + hours; }
            if (minutes < 10) { minutes = "0" + minutes; }
            if (seconds < 10) { seconds = "0" + seconds; }
            return hours + ':' + minutes + ':' + seconds;
        },


        // Router url
        pushUrl(url) {
            this.$router.push(url);
        },

        //Display duration 
        caclDurationDiffDate(startTime, endTime) {
            let totalDurations = moment.duration(moment(endTime).diff(moment(startTime)));
            let durationFormat = `${(totalDurations._data.years > 0 ? `${totalDurations._data.years} year ` : '')}`;
            durationFormat += `${(totalDurations._data.months > 0 ? `${totalDurations._data.months} month ` : '')}`;
            durationFormat += `${(totalDurations._data.days > 0 ? `${totalDurations._data.days}d ` : '')}`;
            durationFormat += `${(totalDurations._data.hours > 0 ? `${totalDurations._data.hours}h ` : '')}`;
            durationFormat += `${(totalDurations._data.minutes > 0 ? `${totalDurations._data.minutes}m ` : '')}`;
            durationFormat += `${(totalDurations._data.seconds > 0 ? `${totalDurations._data.seconds}s ` : '')}`;
            return durationFormat;
        },


        // Feed status
        feedStatusLoading(type) {
            switch (type) {
                case 0:
                    this.loadingStatus = {
                        color: '#9E9E9E',
                        date: moment().format("DD/MM/YYYY hh:mm:ss [GMT]Z"),
                        text: this.$t('loadingStatus.loadingData'),
                    }
                    this.isLoading = true;
                    break;
                case 1:
                    setTimeout(() => {
                        this.loadingStatus = {
                            color: 'green',
                            date: moment().format("DD/MM/YYYY hh:mm:ss [GMT]Z"),
                            text: this.$t('loadingStatus.updateSuccess'),
                        }
                        this.isLoading = false;
                    }, 500);
                    break;
                case 2:
                    setTimeout(() => {
                        this.loadingStatus = {
                            color: 'red',
                            date: moment().format("DD/MM/YYYY hh:mm:ss [GMT]Z"),
                            text: this.$t('loadingStatus.updateFailed'),
                        }
                        this.isLoading = false;
                    }, 500);
                    break;
                default:
                    this.loadingStatus = {
                        color: '#9E9E9E',
                        date: moment().format("DD/MM/YYYY hh:mm:ss [GMT]Z"),
                        text: this.$t('loadingStatus.unknown'),
                    }
                    this.isLoading = false;
                    break;
            }
        },

        // Close pop-up
        closePopup(popup) {
            EventBus.$emit("closePopup", popup);
        },
    },
}